// extracted by mini-css-extract-plugin
export default {"wrapper":"introduction3_wrapper__Bgu5L","button":"introduction3_button__j-CoC"};